export default "__VITE_ASSET__BHJ3Y18t__"